//#region Util Imports

import * as _ from 'underscore'

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'

//#endregion

//#region IMR Imports

import { IMRPopupOptions, IIMRPopup } from '@imr/controls.angularjs/components/overlay/popup'
import { IMRComponentInitializedArgs } from '@imr/controls.angularjs/components/base'

//#endregion

import { TypeHelper, LocalizationHelper } from "../../../../../../helpers"
import { OrderCompleteService } from '../../../../../../services/order'

import { GridOptions, GridController, GridTypes, GridDataSourceType } from '../../../../../common/grid'

import { Enums } from '../../../../../../models/common'
import { OpDepositoryElement } from '../../../../../../models/core'
import { OpValidateInfo } from '../../../../../../models/custom'

import { OrderValidationOptions, IOrderValidation } from './order-validation.interfaces'

export class OrderValidationController implements ng.IComponentController, IOrderValidation {

    // #region Consts

    public static get VALIDATE_GRID_NAME(): string { return 'ORDERS_COMPLETE_ORDER_VALIDATE_GRID_NAME' }

    // #endregion


    //#region Members

    public contentGridOptions: GridOptions
    public options: OrderValidationOptions
    public popupOptions: IMRPopupOptions

    private contentGrid: GridController<OpDepositoryElement>
    private orderContent: OpDepositoryElement[]
    private popup: IIMRPopup;
    private submitButton: DevExpress.ui.dxButton
    private validateInfoList: OpValidateInfo[]

    //#endregion


    //#region Ctrr

    constructor(private completeOrderService: OrderCompleteService) { }

    //#endregion


    //#region ng.IComponentController Implementation

    public $onChanges(changes: { [index: string]: ng.IChangesObject<any> }): void {
        if (TypeHelper.isOptionsDefined(changes)) {
            this.initialize()
        }
    }

    //#endregion


    //#region Component

    private initialize(): void {
        this.initializePopup()
            .then(() => {
                this.onInitialized()
            })
    }

    private reset(): void {
        this.contentGridOptions = null
        this.orderContent = []

        this.toggleSubmitButton(true)
    }

    //#endregion


    //#region Events

    private onInitialized(): void {
        if (this.options != null && _.isFunction(this.options.onInitialized)) {
            this.options.onInitialized(this)
        }
    }

    private onValidated(orderContent: OpDepositoryElement[]): void {
        if (this.options != null && _.isFunction(this.options.onValidated)) {
            this.options.onValidated(orderContent)
        }
    }

    //#endregion


    //#region IOrderValidation Implementation

    public validate(orderContent: OpDepositoryElement[]): void {
        this.orderContent = _.map(orderContent, (contentItem: OpDepositoryElement) => contentItem.clone(true, true, true, true))

        this.popup.toggleLoading(true)
        this.popup.show()

        this.initializeContent()
            .then(() => {
                return this.completeOrderService.validateContent(orderContent)
            })
            .then((validateInfoList: OpValidateInfo[]) => {
                this.validateInfoList = validateInfoList

                _.forEach(orderContent, (contentItem: OpDepositoryElement) => {
                    const validateInfo: OpValidateInfo = this.completeOrderService.getValidateInfoByContentItem(validateInfoList, contentItem)

                    if (validateInfo == null || validateInfo.Status === Enums.ValidationStatus.Correct) {
                        this.contentGrid.setItemDisplayState(contentItem, { validation: Enums.ValidationStatus.Correct })
                    } else {
                        this.contentGrid.setItemDisplayState(contentItem, { validation: Enums.ValidationStatus.Incorrect })
                    }
                })

                this.toggleSubmitButton(_.some(this.validateInfoList, (validationInfo: OpValidateInfo) => validationInfo.Status !== Enums.ValidationStatus.Correct))
                this.contentGrid.dxGrid.refresh()
            })
            .fail(() => {
                this.toggleSubmitButton(true)
            })
            .always(() => {
                this.popup.toggleLoading(false)
            })
    }

    //#endregion


    //#region Content

    private initializeContent(): JQueryPromise<void> {
        this.contentGridOptions = {
            columnsDictionary: this.completeOrderService.getContentGridColumns(),
            dataSourceType: GridDataSourceType.Properties,
            name: OrderValidationController.VALIDATE_GRID_NAME,
            type: GridTypes.MAIN,

            masterDetail: {
                enabled: true,
                template: 'errors',
                autoExpandAll: true,
            },

            buttonsOptions: {
                enabled: true,
                isRefreshButonHidden: true,
                toggleDetailsRowsButtonVisible: true
            },

            dataSourceParser: (contentItem: OpDepositoryElement) => {
                return this.completeOrderService.getContentGridDataSourceParser(this.validateInfoList, contentItem)
            },

            getDataSource: () => {
                return this.orderContent
            },

            onInitialized: (e: any, grid: GridController<any>) => {
                this.contentGrid = grid
            },
        }

        return TypeHelper.onInitializedAll(this.contentGridOptions)
    }

    //#endregion


    //#region Popup

    private initializePopup(): JQueryPromise<void> {
        this.popupOptions = {
            bottomToolbarOptions: {
                innerOptions: {
                    items: [{
                        location: 'after',
                        widget: 'dxButton',
                        options: {
                            text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Submit),

                            onClick: () => {
                                this.onValidated(this.orderContent)
                                this.popup.hide()
                            },

                            onInitialized: (e: any) => {
                                this.submitButton = e.component
                            }
                        }
                    }]
                }
            },

            innerOptions: {
                title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Validate),
                width: '800',

                onHidden: () => {
                    this.reset()
                }
            },

            onInitialized: (e: IMRComponentInitializedArgs<IIMRPopup>) => {
                this.popup = e.component
            }
        }

        return TypeHelper.onInitializedAll(this.popupOptions)
    }

    private toggleSubmitButton(disabled: boolean): void {
        this.submitButton.option('disabled', disabled)
    }

    //#endregion
}